import { Noticia } from './../../shared/dtos/noticia';
import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue';
import { API } from '@/shared/api';
import { ItiString, itiHttpService, itiMessageService } from '@/iti-core-vue';


@Module({
    namespaced: true,
    name: 'NoticiasModule',
    store,
    dynamic: true,
})

class NoticiasModule extends VuexModule {
    public noticias: Noticia[] = [];
    public selectedNoticia: Noticia = new Noticia();


    @Mutation
    public setNoticias(noticias: Noticia[]) {
        this.noticias = noticias;
    }

    @Action
    public async getNoticias() {
        const res = await itiHttpService.get(API.noticias);
        this.context.commit('setNoticias', res);
    }

    @Action
    public async getNoticiaById(id: number) {
        if (id != null) {
            this.noticias.forEach(element => {
                if (element.id == id) {
                    this.context.commit('setNoticiaById', element);
                    return;
                }
            });
        } else {
            return itiMessageService.toast('Error al cargar la notícia', itiMessageService.TypeError, 3000);
        }
    }
    @Mutation
    public setNoticiaById(noticia: Noticia) {
        this.selectedNoticia = new Noticia(noticia);
    }
}

export default getModule(NoticiasModule);